















import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputRadio'
})
export default class InputRadio extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
